import { ReadyState, Store } from './store';
import { action, makeObservable, observable } from 'mobx';

export abstract class BaseStore<T extends number> {
  constructor(
    public state: T,
    public store: Store | undefined,
    public color: string = 'white',
    public logs: string[] = [],
  ) {
    makeObservable(this, {
      state: observable,
      store: observable,
      logs: observable,
      addState: action,
      removeState: action,
      logout: action,
    });
  }

  addState(state: T): void {
    console.log('New state is recorded');
    this.state = (this.state | state) as T;
  }

  removeState(state: T): void {
    console.log('The state is removed');
    this.state = (this.state & ~state) as T;
  }

  setState(state: T): void {
    console.log('The state is forced set');
    this.state = state;
  }

  hasState(state: T): boolean {
    return (this.state & state) === state;
  }

  abstract isReady(): boolean;
  abstract logout(): void;
  abstract reload(): void;
  log(...data: any): void {
    const timestamp = new Date().toLocaleTimeString();
    const header = `%c[${this.constructor.name}] ${timestamp}`;
    const style = `background: #222; color: ${this.color}`;
    console.log(header, style, ...data);
    const flattened = data
      .map(item => (typeof item === 'object' ? JSON.stringify(item, null, 2) : String(item)))
      .join('\n');

    this.logs.push(`[${this.constructor.name}] ${timestamp} ${flattened}`);
  }

  _downloadLogs(filename = 'logs.txt') {
    const blob = new Blob([this.logs.join('\n\n')], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }
}
